import type * as React from 'react';

export function AlertIcon(props?: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="16"
      viewBox="0 0 18 16"
      aria-hidden={true}
      focusable={false}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M.5 15.167h17L9 .167l-8.5 15zm9.5-2H8v-2h2v2zm0-3H8v-4h2v4z"
      />
    </svg>
  );
}
